function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Business_ic_mid",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h192v192H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M37.16 74.6L18 102.42l59.45 27.82L96 102.42l18.55 27.82L174 102.42 154.74 74.6M96 46.78L76.45 28.04 18 56l19.16 18.6"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M95.62 46.78l19.54-18.74L174 56l-19.54 18.6M36 112v26.08L96.05 166 156 138.08V112M96 102.42v61.91"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M37.16 74.6L96 102.42l58.74-27.82L96 46.78 37.16 74.6z"
}));

var SvgBundlesMid = function SvgBundlesMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgBundlesMid;